import { render, staticRenderFns } from "./PackTransactionsList.vue?vue&type=template&id=1565d518&"
import script from "./PackTransactionsList.vue?vue&type=script&lang=js&"
export * from "./PackTransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1565d518')) {
      api.createRecord('1565d518', component.options)
    } else {
      api.reload('1565d518', component.options)
    }
    module.hot.accept("./PackTransactionsList.vue?vue&type=template&id=1565d518&", function () {
      api.rerender('1565d518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/PackTransactionsList.vue"
export default component.exports